import { Address } from "viem";
import { arbitrum, sepolia } from "viem/chains";

type LoanAddressesEntry = {
  loanRouterV2: Address;
  amortizedInterestRateModel: Address;
  simpleInterestRateModel: Address;
  ratioFeeModel: Address;
  absoluteFeeModel: Address;
  usdai: Address;
};

export const LOAN_ADDRESSES: Record<number, LoanAddressesEntry> = {
  [sepolia.id]: {
    loanRouterV2: "0x25Db5FaA18028230584F9c89e5Afb20110F9d5DF",
    amortizedInterestRateModel: "0x20446F8E372F7E534e78Fa1cA45Ccfc8f15664A3",
    simpleInterestRateModel: "0x6Ad96f11cCed9AeCDD743E837b20C87CafD55D2B",
    ratioFeeModel: "0x88d54fDc9c225c7e77615351B0e624EA04212845",
    absoluteFeeModel: "0xC1e8a70B9223Beaaa780f1c8613D46E0B230f84E",
    usdai: "0xeb29fbaa2d509e43313c196a82f4ad75fa251285",
  },
  [arbitrum.id]: {
    loanRouterV2: "0x1C2ED170de32846316784c4fd58A5e3C7563E12f",
    /* Current generation (2026-07-31). To classify an EXISTING loan's model use
     * `interestRateModels.ts`, which knows every generation — older loans embed
     * older addresses. */
    amortizedInterestRateModel: "0x060CE8d04fAc0D85Baa4208331059D8CAb7A6aa1",
    simpleInterestRateModel: "0x5d57017DBB71C65Bf581FE08d5E5dc072beD8b13",
    ratioFeeModel: "0xa10B9DB24220266f282dfFAC538937852FD8E1d3",
    absoluteFeeModel: "0x9372F83b48d36D53b224CE0C254aDCA0318c190D",
    usdai: "0x0a1a1a107e45b7ced86833863f482bc5f4ed82ef",
  },
};
